import { Component, Input } from '@angular/core';
import { DataLayerType } from '../../../models/data-layer-type';
import { NgIf } from '@angular/common';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-data-layer-type-name',
  standalone: true,
  imports: [NgIf, SvgIconComponent],
  templateUrl: './data-layer-type-name.component.html',
  styleUrl: './data-layer-type-name.component.scss',
})
export class DataLayerTypeNameComponent {
  @Input() dataLayerType!: DataLayerType;
}
